import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { Modal } from 'react-bootstrap';

import './styles.scss';

export default function BuildoutModal({ asSidebar, className, ...props }) {
  const modalClasses = classNames(
    'buildout-modal',
    className, {
      'modal--sidebar': asSidebar,
      'modal--fullscreen': props.fullscreen,
      'modal--large': props.size === 'large'
    });

  return (
    <Modal
      className={modalClasses}
      {...props}
    />
  );
}

BuildoutModal.propTypes = {
  asSidebar: PropTypes.bool,
  className: PropTypes.string,
  fullscreen: PropTypes.string,
  size: PropTypes.string
};

BuildoutModal.Body = Modal.Body;
BuildoutModal.Footer = Modal.Footer;
BuildoutModal.Header = function Header({ children, ...props }) {
  return (
    <Modal.Header {...props}>
      <h3 className="m-0">{children}</h3>
    </Modal.Header>
  );
};

BuildoutModal.Header.propTypes = {
  children: PropTypes.node,
};
